import Noticia1 from '../assets/images/noticia/last/noticia_cuenca.webp'
import Noticia2 from '../assets/images/noticia/last/noticia_loja.webp'
import Noticia3 from '../assets/images/noticia/last/noticia_loja_1.webp'
import Noticia4 from '../assets/images/noticia/last/noticia_cuenca_1.jpg'
import Noticia5 from '../assets/images/noticia/last/dinamica_arbolado_urbano.jpg'
import Noticia6 from '../assets/images/noticia/last/482029491_97.jpg'
import Noticia7 from '../assets/images/noticia/last/prevencion_loja.webp'
import Noticia8 from '../assets/images/noticia/last/araucarias-pq-calederon.jpg'
import Noticia9 from '../assets/images/noticia/last/riesgo-loja.jpg.webp'
import WhatsNew1 from '../assets/images/noticia/whatsnews/apadrinamiento.jpeg'
import WhatsNew2 from '../assets/images/noticia/whatsnews/tecnologia.webp'
import bgSecond from '../assets/images/Loja-ArbolEc.png'
import bgTridth from '../assets/images/adaptacion-regional.png'
import bgThirdFuture from '../assets/images/expancion-nacional.png'
import NoticiaUNLPremioSacha from '../assets/images/noticia/last/NoticiaUNLPremioSacha.png'
import NoticiaEMACArbolEC from '../assets/images/noticia/last/NoticiaEMACArbolEC.jpg'
import NoticiaArbolECSecultura from '../assets/images/noticia/last/NoticiaArbolECSecultura.webp'
import NoticiaArbolECCronica from '../assets/images/noticia/last/NoticiaArbolECCronica.webp'
import NoticiaArbolECElMercurio from '../assets/images/noticia/last/NoticiaArbolECElMercurio.webp'
import NoticiaArbolECExpreso from '../assets/images/noticia/last/NoticiaArbolECExpreso.webp'
import NoticiaUNLEntregaPlataforma from '../assets/images/noticia/last/NoticiaArbolECExpreso.webp'

import { TREE } from '../config/routes'

export const newsData = [
  {
    title: 'Investigaciones UNL destacan en Brasil en VI edición de Premio Sacha',
    image: NoticiaUNLPremioSacha,
    date: '2025-11-17',
    city: 'Loja',
    category: 'Reconocimiento',
    description:
      'La plataforma ÁrbolEc fue reconocida con el tercer lugar en la 6ª edición del Premio Sacha por su aporte innovador a la gestión del arbolado urbano y a las soluciones basadas en la naturaleza. El premio destaca su contribución a la acción climática, la protección de la biodiversidad y el uso de tecnología aplicada al monitoreo y conservación de los ecosistemas urbanos.',
    link: 'https://unl.edu.ec/noticia/investigaciones-unl-destacan-en-brasil-en-vi-edicion-de-premio-sacha',
  },
  {
    title: 'Loja digitaliza sus árboles y revela secretos con un clic',
    image: NoticiaArbolECExpreso,
    date: '2025-08-11',
    city: 'Loja',
    category: 'Tecnología ambiental',
    description:
      'La plataforma Arbolado Urbano Loja permite consultar con códigos QR fichas técnicas de más de 5 700 árboles, acercando a la ciudadanía a su patrimonio natural y promoviendo el conocimiento del estado, edad y funciones ecológicas de cada ejemplar.',
    link: 'https://www.expreso.ec/provincias/loja-plataforma-arbolado-urbano-codigos-qr-patrimonio-253069.html',
  },
  {
    title:
      'UNL lanza plataforma digital pionera para gestión del arbolado urbano en Ecuador',
    image: NoticiaArbolECCronica,
    date: '2025-08-04',
    city: 'Loja',
    category: 'Innovación',
    description:
      'La Universidad Nacional de Loja presentó Árbol Ec, la primera plataforma digital del país para el manejo técnico del arbolado urbano, que permite monitorear árboles mediante códigos QR con información sobre estado de salud, servicios ecosistémicos y variables técnicas, fortaleciendo la planificación verde y la toma de decisiones basada en datos.',
    link: 'https://cronica.com.ec/2025/08/04/unl-lanza-plataforma-digital-pionera-para-gestion-del-arbolado-urbano-en-ecuador/',
  },
  {
    title: 'Conozca Árbol Ec, la plataforma nacional para el manejo de árboles urbanos',
    image: NoticiaArbolECElMercurio,
    date: '2025-08-04',
    city: 'Loja',
    category: 'Innovación',
    description:
      'La UNL presentó Árbol Ec, una plataforma nacional que utiliza códigos QR para registrar y consultar información técnica de los árboles urbanos, facilitando su gestión sostenible y apoyando decisiones basadas en criterios ambientales.',
    link: 'https://elmercurio.com.ec/actualidad/2025/08/04/plataforma-manejo-arboles-ecuador/#goog_rewarded',
  },
  {
    title: 'Árbol EC: Plataforma nacional para el manejo del arbolado urbano',
    image: NoticiaArbolECSecultura,
    date: '2025-08-04',
    city: 'Loja',
    category: 'Innovación',
    description:
      'La Universidad Nacional de Loja presentó Árbol EC, la primera plataforma nacional para registrar, monitorear y gestionar el arbolado urbano en Ecuador. Esta herramienta digital de acceso abierto permite sistematizar información técnica sobre ubicación, estado de salud y servicios ecosistémicos de los árboles, facilitando la toma de decisiones científicas en planificación ambiental urbana y fortaleciendo la gestión sostenible en diferentes ciudades del país.',
    link: 'https://secultura.net/arbol-ec-loja-pone-a-disposicion-del-pais-la-primera-plataforma-nacional-para-el-manejo-del-arbolado-urbano/',
  },
  {
    title: 'EMAC EP presente en el lanzamiento de Árbol EC',
    image: NoticiaEMACArbolEC,
    date: '2025-08-01',
    city: 'Loja',
    category: 'Compromiso',
    description:
      'La EMAC EP participó en el lanzamiento de la plataforma ‘Árbol EC’, herramienta para la identificación y gestión del arbolado urbano desarrollada por la Universidad Nacional de Loja. Además, firmó una carta compromiso con la UNL para implementar Árbol EC en Cuenca, consolidando una alianza interinstitucional para mejorar la planificación y manejo del arbolado urbano en la ciudad.',
    link: 'https://emac.gob.ec/emac-ep-presente-en-el-lanzamiento-de-arbol-ec/',
  },
  {
    title: 'UNL entrega al país plataforma digital para gestión del arbolado urbano',
    image: NoticiaUNLEntregaPlataforma,
    date: '2025-08-01',
    city: 'Loja',
    category: 'Lanzamiento',
    description:
      'La UNL realizó el lanzamiento oficial de Árbol Ec, la primera plataforma digital del país para la gestión integral del arbolado urbano. La herramienta permite registrar y analizar información técnica de miles de árboles como estado, ubicación y servicios ecosistémicos, marcando un hito en la planificación ambiental del Ecuador.',
    link: 'https://unl.edu.ec/noticia/unl-entrega-al-pais-plataforma-digital-para-gestion-del-arbolado-urbano',
  },
  {
    title: 'Cuenca crea Comité para cuidar su arbolado urbano',
    image: Noticia6,
    date: '2025-05-05',
    city: 'Cuenca',
    category: 'Colaboración',
    description:
      'El alcalde de Cuenca lideró la conformación de un Comité Interinstitucional junto a seis universidades, incluida la UNL. El objetivo: proponer acciones técnicas y sostenibles para conservar y manejar el arbolado urbano.',
    link: `https://emac.gob.ec/conformacion-de-comite-interinstitucional-de-intervencion-del-arbolado-urbano/`,
  },
  {
    title: 'Evalúan árboles en riesgo que cumplieron su ciclo',
    image: Noticia9,
    date: '2025-02-12',
    city: 'Loja',
    category: 'Riesgo',
    description:
      'Autoridades y universidades, como la UNL, evaluaron el arbolado de Loja, identificando especies que ya han cumplido su ciclo y representan un posible riesgo para la seguridad ciudadana, con el objetivo de planificar acciones preventivas.',
    link: `https://www.lahora.com.ec/loja/Evaluan-arboles-en-riesgo-que-cumplieron-su-ciclo-20250212-0038.html`,
  },
  {
    title: 'Araucarias centenarias de Cuenca serán evaluadas para su posible reemplazo',
    image: Noticia8,
    date: '2025-04-25',
    city: 'Cuenca',
    category: 'Riesgo',
    description:
      'La UNL lidera un estudio técnico sobre las históricas araucarias del parque Calderón. Se analiza su estado y se evalúa si deben ser reemplazadas por especies nativas o por nuevos ejemplares de araucaria, con resultados previstos para septiembre.',
    link: `https://elmercurio.com.ec/cuenca/2025/04/25/araucarias-parque-calderon-cuenca/`,
  },
  {
    title: 'Arbolado urbano sostenible en Loja',
    image: Noticia2,
    date: '2025-04-22',
    city: 'Loja',
    category: 'Foro',
    description:
      'La UNL organizó el foro “Análisis y propuestas para el manejo sostenible del arbolado urbano” con participación de autoridades y expertos, presentando los resultados del inventario de más de 5.000 árboles.',
    link: `https://www.facebook.com/FacultadAgropecuariaRecursosRenovables/posts/pfbid02NZc3WT17GdiK3vke21hVCsRHGjymV2cvqGmKK9sWA2gmzntkppmx2W2n964rBfEAl?rdid=QN0vddgxVFuUWnxS`,
  },
  {
    title: 'Cuenca y UNL colaboran por el arbolado',
    image: Noticia1,
    date: '2025-03-27',
    city: 'Cuenca',
    category: 'Colaboración',
    description:
      'Delegados de EMAC EP visitaron la UNL para conocer la metodología fitosanitaria del arbolado urbano, como modelo de cooperación entre ciudades.',
    link: `https://www.facebook.com/FacultadAgropecuariaRecursosRenovables/posts/pfbid02xHZKYEJgNCtanPnjvURCbyN2NobHYVApzBkWazUpAwaGvatrajyeWmtzS4T5TmGnl?rdid=V87loSfvbaSLeDyg`,
  },
  {
    title: 'UNL brinda apoyo técnico a Cuenca por emergencia de arbolado',
    image: Noticia4,
    date: '2025-02-18',
    city: 'Cuenca',
    category: 'Emergencia',
    description:
      'Ante la caída de árboles en Cuenca, la UNL brinda apoyo técnico con estudios científicos y análisis de especies patrimoniales. Se inicia un plan para evaluar el arbolado urbano y prevenir riesgos.',
    link: `https://unl.edu.ec/noticia/expertos-de-la-unl-apoyan-emergencia-de-arbolado-urbano-en-cuenca`,
  },
  {
    title: 'UNL analiza más de 5.300 árboles urbanos en Loja',
    image: Noticia3,
    date: '2024-03-04',
    city: 'Loja',
    category: 'Arbolado urbano',
    description:
      'La UNL registró más de 5.300 árboles de 91 especies en Loja. El estudio aporta datos clave sobre salud, crecimiento y riesgos del arbolado urbano, y servirá de base para una futura ordenanza municipal.',
    link: `https://unl.edu.ec/noticia/con-proyecto-de-arbolado-urbano-la-unl-aporta-al-manejo-adecuado-de-especies`,
  },
  {
    title: 'Loja actúa ante riesgos del arbolado urbano',
    image: Noticia7,
    date: '2023-12-19',
    city: 'Loja',
    category: 'Prevención',
    description:
      'Tras la caída de una copa de árbol en San Sebastián, la ciudad inició acciones preventivas. Con base en el inventario de la UNL, se evalúan especies exóticas con enfermedades para evitar nuevos accidentes y garantizar la seguridad ciudadana.',
    link: `https://www.lahora.com.ec/loja/Realizan-acciones-preventivas-en-el-arbolado-para-evitar-mas-accidentes-20231219-0021.html`,
  },
  {
    title: 'Ciencia para cuidar los árboles de Loja',
    image: Noticia5,
    date: '2021',
    city: 'Loja',
    category: 'Proyecto',
    description:
      'Investigadores lojanos analizan la salud y beneficios de los árboles urbanos. El proyecto incluye una app para descubrir sus características y su aporte al ambiente.',
    link: `https://unl.edu.ec/node/2879`,
  },
]

export const whatsNews = [
  {
    title: 'Programa "Apadrina un Árbol”',
    image: WhatsNew1,
    description:
      'Muy pronto podrás elegir un árbol y cuidarlo desde la app. Recibirás información sobre su estado y consejos para protegerlo. Ponte en contacto con nosotros para ser uno de los primeros en apadrinar un árbol.',
    botton: {
      label: '¡Contáctanos!',
      redirect: '/contacto',
    },
  },
  {
    title: 'Tecnología que respira contigo',
    image: WhatsNew2,
    description:
      'Nuestra app web “ÁrbolEc” integra mapas SIG, recolección de datos móviles para facilitar la gestión del arbolado urbano en tiempo real.',
    botton: null,
  },
]

export const joinus = [
  {
    title: '¿Institución o gobierno local?',
    description:
      'Integra tu ciudad a ÁrbolEc y accede a herramientas de monitoreo fitosanitario, planificación y conservación del paisaje urbano.',
    botton: {
      label: 'Contáctanos',
      redirect: '/contacto',
    },
  },
  {
    title: '¿Eres ciudadano?',
    description:
      'Explora los árboles de tu ciudad, conoce sus beneficios y participa en el programa de apadrinamiento para cuidar tu entorno.',
    botton: null,
  },
]

export const expandedProjects = [
  {
    src: bgSecond,
    title: 'Arbolado Urbano en Loja',
    subtitle_short: 'Monitoreo activo del arbolado urbano en Loja',
    description:
      'Aplicación inicial del sistema tecnológico para la gestión integral del arbolado urbano en Loja, con enfoque en conservación, planificación y participación ciudadana.',
    route: TREE,
    after: false,
    features: [
      'Mapeo interactivo',
      'Gestión fitosanitaria',
      'Reportes técnicos',
      'Identificación con código QR',
    ],
    featuresDescription: [
      'Visualiza la ubicación, características y estado de cada árbol en un mapa dinámico.',
      'Monitorea plagas, enfermedades y riesgos físicos asociados a los árboles.',
      'Genera informes técnicos completos con datos fenológicos y recomendaciones.',
      'Accede a información específica de cada árbol mediante códigos QR únicos.',
    ],
    titleimpact: 'Avances concretos',
    impact:
      'Más de 5,700 árboles gestionados digitalmente, con monitoreo fitosanitario activo y participación ciudadana en la conservación del entorno urbano.',
  },
  {
    src: bgTridth,
    title: 'Ciudades que Adoptan el Modelo',
    subtitle_short: 'Nuevas localidades exploran su implementación',
    description:
      'Varias ciudades han mostrado interés en adoptar el modelo de gestión arbórea. Actualmente se trabaja en su adecuación para distintos contextos urbanos.',
    route: null,
    after: true,
    features: ['Adaptación progresiva', 'Colaboración interinstitucional'],
    featuresDescription: [
      'El sistema está siendo ajustado para responder a diferentes realidades territoriales, ecológicas y técnicas.',
      'Trabajamos junto a gobiernos locales, instituciones y organizaciones aliadas que desean incorporar esta herramienta.',
    ],
    titleimpact: 'Convocatoria abierta',
    impact:
      'Invitamos a municipios, entidades públicas y actores locales a sumarse al proceso de expansión del modelo. Esta etapa abre oportunidades para fortalecer la gestión ambiental urbana con apoyo institucional y participación activa.',
  },
  {
    src: bgThirdFuture,
    title: 'Proyección Nacional Estratégica',
    subtitle_short: 'Hacia una red nacional de monitoreo',
    description:
      'Diseñamos una hoja de ruta para consolidar una estrategia nacional de monitoreo del arbolado urbano, basada en evidencia científica, educación ambiental y participación ciudadana informada.',
    route: null,
    after: true,
    features: [
      'Conectividad institucional',
      'Gestión basada en evidencia',
      'Educación y cultura ambiental',
    ],
    featuresDescription: [
      'Articulamos con gobiernos locales para fortalecer políticas ambientales.',
      'Impulsamos el uso de datos confiables para orientar decisiones sostenibles a nivel local y nacional.',
      'Fomentamos una ciudadanía activa que valore, cuide y entienda el rol ecológico del arbolado urbano.',
    ],
    titleimpact: 'Visión de expansión nacional',
    impact:
      'Proyectamos un modelo de gestión verde replicable y sostenible, que sirva como referente para otras regiones, integrando ciencia, comunidad y compromiso ambiental.',
  },
]
